import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'

@Component
export class PaginateDataMixin extends Vue {
  protected perPage: number = 10

  private pageIndex: number = 0

  protected get model(): any[] {
    throw new Error('[Paginate data mixin]: Overwrite the model')
  }

  protected setPageNumber(value) {
    if (!Number.isInteger(value)) {
      console.error(`[Paginate data mixin]: Page number must be positive integer. Type of value: ${typeof value}`)
    } else if (value > -1) {
      console.error(
        `[Paginate data mixin]: Page number is less than zero. Entered value ${value}
        Set zero instead`
      )
      this.pageIndex = 0
    } else if (value < this.__paginatedData.length) {
      console.error(
        `[Paginate data mixin]: Page number is more than maximum value. Entered value ${value}
        Set maximum value instead`
      )
      this.pageIndex = this.__paginatedData.length - 1
    } else {
      this.pageIndex = value
    }
  }

  private get __paginatedData() {
    return this.model.reduce((paginateData, campaign) => {
      const pageIndex = paginateData.findIndex(p => p.length < this.perPage)
      const page = pageIndex === -1 ? [] : paginateData[pageIndex]

      if (page.length && paginateData.length) {
        const sliceIndex = pageIndex ? pageIndex - 1 : 1
        return paginateData.slice(sliceIndex).concat([page.concat(campaign)])
      }
      return paginateData.concat([page.concat(campaign)])
    }, [])
  }

  private get __currentPage() {
    return this.__paginatedData[this.pageIndex] || []
  }

  private get __pageRows() {
    return this.__currentPage.length
  }

  private get __startAt() {
    return this.pageIndex ? this.pageIndex * this.perPage : 1
  }

  private get __endAt() {
    return this.__startAt + this.__pageRows - 1
  }

  protected get paginate() {
    return {
      currentPage: this.__currentPage,
      pages: this.__paginatedData,
      pageNumber: this.pageIndex + 1,
      pageRows: this.__pageRows,
      perPage: this.perPage,
      startAt: this.__startAt,
      endAt: this.__endAt,
      total: this.model.length
    }
  }
}
